module.exports = __webpack_public_path__ + "static/img/硕士_2022_娄宇航_louyuhang@nwafu.edu.cn.d0aedf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/硕士_2022_娄宇航_louyuhang@nwafu.edu.cn.jpg
// module id = TSoV
// module chunks = 6